export default function PageNotFound() {
  return "404 - Not found";
}
